import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536fc456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-selector" }
const _hoisted_2 = { class: "tag-popover-content" }
const _hoisted_3 = { class: "tag-list" }
const _hoisted_4 = {
  key: 0,
  class: "selected-tags mt-2"
}

import { ref, computed, onMounted, watch } from "vue";
import { ArrowDown } from "@element-plus/icons-vue";
import { axiosInstance as axios } from "@/core/services/api.client";


export default /*#__PURE__*/_defineComponent({
  __name: 'TagSelector',
  props: {
    type: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const availableTags = ref<Array<{ id: number; type: string; name: string }>>(
  []
);
const selectedTagIds = ref<Set<number>>(new Set());
const isLoading = ref(false);

const isTagSelected = (tagId: number) => {
  return selectedTagIds.value.has(tagId);
};

const selectedTagNames = computed(() => {
  return Array.from(selectedTagIds.value)
    .map((id) => {
      const tag = availableTags.value.find((t) => t.id === id);
      return tag?.name || "";
    })
    .filter((name) => name !== "");
});

const fetchTags = async () => {
  isLoading.value = true;
  try {
    const { data } = await axios.get(`/api/v2/tenant/tag/all`, {
      params: { type: props.type },
    });
    availableTags.value = data;

    // Initialize selectedTagIds based on modelValue
    if (props.modelValue && props.modelValue.length > 0) {
      const newSet = new Set<number>();
      props.modelValue.forEach((tagName) => {
        const tag = availableTags.value.find((t) => t.name === tagName);
        if (tag) {
          newSet.add(tag.id);
        }
      });
      selectedTagIds.value = newSet;
    }
  } catch (error) {
    console.error("Failed to fetch tags:", error);
  } finally {
    isLoading.value = false;
  }
};

const toggleTag = (tagId: number) => {
  const newSet = new Set(selectedTagIds.value);
  if (newSet.has(tagId)) {
    newSet.delete(tagId);
  } else {
    newSet.add(tagId);
  }
  selectedTagIds.value = newSet;
  emit("update:modelValue", selectedTagNames.value);
};

const removeTag = (tagName: string) => {
  const tag = availableTags.value.find((t) => t.name === tagName);
  if (tag) {
    const newSet = new Set(selectedTagIds.value);
    newSet.delete(tag.id);
    selectedTagIds.value = newSet;
    // Immediately compute and emit the updated tag names
    const updatedNames = Array.from(newSet)
      .map((id) => {
        const t = availableTags.value.find((item) => item.id === id);
        return t?.name || "";
      })
      .filter((name) => name !== "");
    emit("update:modelValue", updatedNames);
  }
};

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal && availableTags.value.length > 0) {
      const newSet = new Set<number>();
      newVal.forEach((tagName) => {
        const tag = availableTags.value.find((t) => t.name === tagName);
        if (tag) {
          newSet.add(tag.id);
        }
      });
      selectedTagIds.value = newSet;
    } else if (!newVal || newVal.length === 0) {
      selectedTagIds.value = new Set();
    }
  }
);

onMounted(() => {
  fetchTags();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: "bottom-start",
      width: 300,
      trigger: "click",
      disabled: isLoading.value
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, { disabled: isLoading.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("title.tags")) + " ", 1),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowDown))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTags.value, (tag) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                key: tag.id,
                "model-value": isTagSelected(tag.id),
                label: tag.name,
                class: "tag-checkbox",
                onChange: ($event: any) => (toggleTag(tag.id))
              }, null, 8, ["model-value", "label", "onChange"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["disabled"]),
    (selectedTagNames.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTagNames.value, (tagName) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              key: tagName,
              closable: "",
              onClose: ($event: any) => (removeTag(tagName)),
              class: "me-2 mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tagName), 1)
              ]),
              _: 2
            }, 1032, ["onClose"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})